import $ from 'jquery'

import Routes from '@/router/routes'
import Session from '@/components/general/session/session'

export default {
  name: 'private-aside',
  data () {
    return {
      smallDevice: false,
      active: false,
      routes: Routes,
      sessionUser: {}
    }
  },
  methods: {
    firstDisplay () {

      if (!this.smallDevice) {

        this.active = true

      }

    },
    logout () {

      Session.logout()

    }
  },
  created () {

    let vm = this

    window.innerWidth <= 767 ? vm.smallDevice = true : vm.smallDevice = false

    vm.firstDisplay()

    $(window).resize(function () {

      if (window.innerWidth <= 767) {

        vm.smallDevice = true

        if (vm.active) {

          vm.active = false

        }

      } else {

        vm.smallDevice = false

        if (!vm.active) {

          vm.active = true

        }

      }

    })

    vm.$root.$on('asideToggle', () => {

      if (vm.active) {

        vm.active = false

      } else {

        vm.active = true

      }

    })

    vm.sessionUser = JSON.parse(localStorage.getItem('sessionUser'))

  }
}



// WEBPACK FOOTER //
// ./src/components/private/aside/script.js